import { parseExpression, evalNode } from './ast.js'

export function ejecutarExpresion(expresion, datos, errors = [], runtimeContext = {}) {
  const ast = parseExpression(expresion, errors)
  return evalNode(ast, datos, errors, runtimeContext)
}
